import "../../assets/styles/component/sidebar.css";
import logoSidebar from "../../assets/images/logo_sidebar.png";
import Swal from "sweetalert2";
import { Box } from "@mui/material";
import { check_role } from "../../controllers/helps.controller";
import { useIntl } from 'react-intl';
const { REACT_APP_VERSION } = process.env;

const Sidebar = ({ navstate, setNavstate }) => {
  const intl = useIntl();

  const handleHDSD = () => {
    Swal.fire({
      title: intl.formatMessage({ id: 'sidebar.userGuide.title' }),
      width: 1200,
      html: `
        <div class="hdsd-modal">
          <h3 class="hdsd-title">${intl.formatMessage({ id: 'sidebar.hdsd.createCode' })}</h3>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.issueCode' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.uploadTemplate' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.promoCode' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.searchConditions' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.rewardPoints' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.rewardPointsDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.codeQuantity' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.codeQuantityDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.codeLength' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.codeLengthDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.usageTime' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.usageTimeDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.receiveTimes' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.receiveTimesDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.depositWithdrawConditions' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.depositWithdrawConditionsDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.status' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.statusDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.randomCharacters' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.randomCharactersDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.checkIpFp' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.checkIpFpDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.internalMail' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.internalMailDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.qrCode' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.qrCodeDescription' })}
          </p>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.codeType' })}:</b>
            ${intl.formatMessage({ id: 'sidebar.form.codeTypeDescription' })}
          </p>

          <h3>${intl.formatMessage({ id: 'sidebar.hdsd.uploadCode' })}</h3>
          <p class="content-modal">
            ${intl.formatMessage({ id: 'sidebar.form.uploadTemplate' })}
          </p>
          <h3>${intl.formatMessage({ id: 'sidebar.hdsd.findCode' })}</h3>
          <p class="content-modal">
            ${intl.formatMessage({ id: 'sidebar.form.searchConditions' })}
          </p>
          <h3>${intl.formatMessage({ id: 'sidebar.hdsd.deleteCode' })}</h3>
          <p class="content-modal">
            <b>- ${intl.formatMessage({ id: 'sidebar.form.deleteNote' })}</b>
            ${intl.formatMessage({ id: 'sidebar.form.deleteInstruction' })}<br></br>
            ${intl.formatMessage({ id: 'sidebar.form.deleteWarning' })}
          </p>
        </div>
        `,
    });
  };

  return (
    <Box id="sidebar" className={navstate ? "" : "sidebar-hide"}>
      <Box className="sidebar-cont">
        <img className="logo-sidebar" src={logoSidebar} alt="" />
        <i
          className="fa-solid fa-arrow-right-from-bracket icon-collapse"
          onClick={() => {
            setNavstate(!navstate ?? false);
            localStorage.setItem("nav-state", !navstate ?? false);
          }}
          role="switch"
        />
        <Box className="header-sidebar">
          <i className="fa-solid fa-circle-user"></i>
          <span className="user-text" title={intl.formatMessage({ id: 'sidebar.userAccount' })}>
            {localStorage.getItem("username-redeem")?.toUpperCase()}
          </span>
        </Box>
        <Box>
          {/* className={navstate ? "body-sidebar" : "main-wide body-sidebar"} */}
          <span className="title-body-sidebar">
            {intl.formatMessage({ id: 'sidebar.menu' })}
          </span>
          <Box className="menu-cont">
            <a href="/">
              <Box className="menu-btn-cont">
                <Box className="menu-btn btn-top">
                  <Box className="title-btn">
                    {intl.formatMessage({ id: 'sidebar.codeManagement' })}
                  </Box>
                </Box>
              </Box>
            </a>
            {check_role("superadmin") && (
              <a href="/user-manager" className="user-manager-Box">
                <Box className="menu-btn-cont">
                  <Box className="menu-btn">
                    <Box className="title-btn">
                      {intl.formatMessage({ id: 'sidebar.account' })}
                    </Box>
                  </Box>
                </Box>
              </a>
            )}
            {check_role("superadmin") && (
              <a href="/setting">
                <Box className="menu-btn-cont">
                  <Box className="menu-btn">
                    <Box className="title-btn">
                      {intl.formatMessage({ id: 'sidebar.settings' })}
                    </Box>
                  </Box>
                </Box>
              </a>
            )}
            {check_role("superadmin") && (
              <a href="/ip">
                <Box className="menu-btn-cont">
                  <Box className="menu-btn">
                    <Box className="title-btn">
                      {intl.formatMessage({ id: 'sidebar.whiteIp' })}
                    </Box>
                  </Box>
                </Box>
              </a>
            )}
            <div onClick={handleHDSD}>
              <Box className="menu-btn-cont">
                <Box className="menu-btn btn-bottom">
                  <Box className="title-btn">
                    {intl.formatMessage({ id: 'sidebar.guide' })}
                  </Box>
                </Box>
              </Box>
            </div>
          </Box>
        </Box>
        <Box className="footer-sidebar">
          <Box className="footer-text system-text">FREECODE</Box>
          <Box className="footer-text">V - {REACT_APP_VERSION}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Sidebar;
